'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataGridSelectionCell", {
    enumerable: true,
    get: function() {
        return DataGridSelectionCell;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDataGridSelectionCell = require("./useDataGridSelectionCell");
const _renderDataGridSelectionCell = require("./renderDataGridSelectionCell");
const _useDataGridSelectionCellStylesstyles = require("./useDataGridSelectionCellStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DataGridSelectionCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDataGridSelectionCell.useDataGridSelectionCell_unstable)(props, ref);
    (0, _useDataGridSelectionCellStylesstyles.useDataGridSelectionCellStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDataGridSelectionCellStyles_unstable')(state);
    return (0, _renderDataGridSelectionCell.renderDataGridSelectionCell_unstable)(state);
});
DataGridSelectionCell.displayName = 'DataGridSelectionCell';
